import styled from '@emotion/styled'

export const Button = styled.button`
  &:not(:disabled),
  &[type='button']:not(:disabled),
  &[type='reset']:not(:disabled),
  &[type='submit']:not(:disabled) {
    cursor: pointer;
  }
  border-radius: 0.25rem;
  -webkit-appearance: button;
  color: #fff;
  padding-inline: 1.5rem;
  padding-block: 0.5rem;
  border: 1px solid #dee2e6;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.2s;
  font-weight: 600;
  font-size: 13px;
  line-height: 17.7px;
  text-transform: capitalize;
  font-family: Open Sans, sans-serif;
  min-width: 89px;
  margin: 0;
  overflow: visible;
  background-image: none;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  background-color: rgb(255, 80, 0);
  &:hover {
    background-color: rgb(230, 79, 10);
  }
  &:disabled {
    user-select: none;
    background-color: #bbb;
    cursor: not-allowed;
  }
`
